import type { shell as en } from '@/i18n/locales/en/shell';
import type { Translation } from '@/i18n/types';

export const shell: Translation<typeof en> = {
  notFound: {
    title: 'Sayfa bulunamadı',
    body: 'Bu adres mevcut değil.',
    backLink: 'Genel bakışa dön',
  },
  configWarning: {
    body: '<0>Eksik yapılandırma.</0> {{missing}} eksik. Yerel geliştirme için bunları <1>.env.local</1> içinde ayarlayın (bkz. <2>.env.example</2>), veya bir dağıtım için container ortamında ayarlayın.',
  },
  skipToContent: 'İçeriğe geç',
  brandName: 'NOLATR',
  mainNav: 'Ana',
  sectionNav: 'Bölüm',
  accountNav: 'Hesap',
  openMainMenu: 'Menüyü aç',
  closeMainMenu: 'Menüyü kapat',
  activeCompany: 'Etkin şirket',
  profileStub: {
    title: 'Profil',
    lead: 'Profil sayfanız yolda — şimdilik bu, sizi gönderecek bir yer olsun diye konulmuş geçici bir yer tutucudur.',
  },
  manageStub: {
    title: 'Yönet',
    lead: 'Menüden bir bölüm seçin.',
  },
};
